var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"dialog-title-adm"},[_vm._t("title")],2),_vm._t("content"),_vm._t("btn"),_vm._t("close")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }